__turbopack_context__.v({
  "aside": "SectionHeading-module__7zhw3a__aside",
  "compact": "SectionHeading-module__7zhw3a__compact",
  "description": "SectionHeading-module__7zhw3a__description",
  "heading": "SectionHeading-module__7zhw3a__heading",
  "meta": "SectionHeading-module__7zhw3a__meta",
  "title": "SectionHeading-module__7zhw3a__title",
  "titleRow": "SectionHeading-module__7zhw3a__titleRow",
});
